import { Navigate } from 'react-router-dom';

/**
 * Phase 7-avatar shipped a placeholder here. Phase 7-dashboard-b replaces it with a
 * permanent redirect to `/dashboard/profile` so any avatar-menu / older bookmark
 * links land on the real dashboard surface (analysis §7 Q8 resolution).
 */
export function ProfilePage() {
  return <Navigate to="/dashboard/profile" replace />;
}
